<template>
  <div style="margin-left:auto;margin-right:auto;margin-top:40px;margin-bottom:40px">
    <p style="text-align:center;color:#7a7157">See online portfolios of the world's leading illustrators 
      <a style="color:#7a7157;text-decoration:underline" :href="'https://www.illustrationx.com/' + cclink">here</a>.</p>
    <div style="text-align:center;padding-top:30px">
      <img :src="$assetUrl('main-logo.png')" alt="IllustrationX - Connecting You to a World of Illustration" width="424" />
    </div>
    <div style="width:590px;background-color:#ffffff;margin-left:auto;margin-right:auto;border:1px solid #000000;margin-top:50px;box-shadow:0 0 12px rgba(0,0,0,0.3)">
      <slot></slot>
      <style-browser :cclink="cclink" :kidsbooks="kidsbooks" />
      <div style="text-align:center;color:#7a7157;margin:0 35px;padding-top:35px;padding-bottom:45px;border-top:1px solid #7a7157">
        <p>Follow us</p>
        <div>
          <a href="https://www.pinterest.com/weareillustrationx/"><img :src="$assetUrl('pinterest.png')" /></a> &nbsp;
          <a href="https://www.facebook.com/weareillustrationx"><img :src="$assetUrl('facebook.png')" /></a> &nbsp;
          <a href="https://twitter.com/_illustrationx"><img :src="$assetUrl('twitter.png')" /></a> &nbsp;
          <a href="https://www.linkedin.com/company/illustrationx"><img :src="$assetUrl('linkedin.png')"/></a> &nbsp;
          <a href="https://www.instagram.com/weareillustrationx/"><img :src="$assetUrl('instagram.png')" /></a>
        </div>
        <div style="padding:12px 0">
          This enewsletter was sent to you by
        </div>
        <div style="padding:12px 0">
          <img :src="$assetUrl('logo-footer.png')" />
        </div>
        <div style="padding:6px 0">
          with offices in 
        </div>
        <div style="padding:6px 0">
          UK | South America | USA | France 
        </div>
        <div style="padding:6px 0">
          Germany | China | Australia | India 
        </div>
        <div style="padding:16px 0 6px 0">
          <a style="text-decoration:none;color:#7a7157" href="mailto:hello@illustrationx.com">hello@illustrationx.com</a> 
        </div>
        <div style="padding:6px 0">
          <a style="color:#ce0e2d;font-weight:500;text-decoration:none" :href="'https://www.illustrationx.com/' + cclink">www.illustrationx.com</a> 
        </div>
        <ten-million-trees :cclink="cclink" />
        <bot-link :cclink="cclink"></bot-link>
      </div>
    </div>
  </div>

</template>

<script>
import StyleBrowser from '../components/StyleBrowser.vue'
import TenMillionTrees from '../components/TenMillionTrees.vue'
import BotLink from '../components/BotLink.vue'
export default {
  props: {
    cclink: String,
    kidsbooks: Boolean
  },
  components: {
    StyleBrowser,
    TenMillionTrees,
    BotLink
  }
}
</script>

<style>

</style>